<script setup lang="ts">
// Overrides @basecom-gmbh/pond/components/Navigation/NavigationMainItem.vue
// changes: change active & default class styling, add icon which indicates flyout
import type { Schemas } from '@shopware/api-client/api-types';

defineProps<{
    navigationElement: Schemas['Category'];
}>();

const navigationItem = ref(null);

const { isOutside: isOutsideNavItem } = useMouseInElement(navigationItem);
const debounced = refDebounced(isOutsideNavItem, 300);
</script>

<template>
    <div
        ref="navigationItem"
        class="flex cursor-pointer items-center gap-1.5 text-nowrap"
    >
        <!-- IDS-188: remove formkit icon -->
        <NavigationLink
            :navigation-element="navigationElement"
            classes="font-regular text-neutral-800 text-md hover:text-neutral-800"
            active-classes="font-bold"
            :as-link="navigationElement.type !== 'folder'"
        />
    </div>
    <ClientOnly>
        <NavigationFlyout
            v-if="navigationElement?.childCount > 0"
            :navigation-element="navigationElement"
            :parent-hovered="!debounced"
            class="z-20"
        />
        <template #fallback />
    </ClientOnly>
</template>
